import { useEffect, useState } from 'react';
import { useMatches, useNavigation } from 'react-router';

import { TUseNavigationLoaderOptions } from '@/shared/hooks/use-navigation-loader/use-navigation-loader.types';
import { THandle } from '@/shared/types/router.types';

const DEFAULT_LOADER_DISPLAY_DELAY = 500;

const isWithin = (pathname: string, base: string) =>
  pathname === base ||
  pathname.startsWith(base.endsWith('/') ? base : `${base}/`);

export const useNavigationLoader = ({
  delay = DEFAULT_LOADER_DISPLAY_DELAY,
}: TUseNavigationLoaderOptions = {}) => {
  const navigation = useNavigation();
  const matches = useMatches();
  const [displayNavigationLoader, setDisplayNavigationLoader] = useState(false);

  const pendingPathname = navigation.location?.pathname;
  const staysInsideOwnLoader =
    !!pendingPathname &&
    matches.some(
      (match) =>
        (match.handle as THandle | undefined)?.suppressNavigationLoader &&
        isWithin(pendingPathname, match.pathname),
    );

  useEffect(() => {
    if (navigation.state === 'idle' || staysInsideOwnLoader) {
      setDisplayNavigationLoader(false);
      return;
    }

    const timer = setTimeout(() => {
      setDisplayNavigationLoader(true);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay, navigation.state, staysInsideOwnLoader]);

  return displayNavigationLoader;
};
